import MojitoModules from 'mojito/modules';

import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateParticipants} from '#core/application/modules/tiles/participants/index.js';
import {generateEventTimingStatus} from '#core/application/modules/tiles/event-timing-status/index.js';
import {generateBaseScoreboard, generateScoreboard} from '#core/application/modules/tiles/scoreboard/index.js';
import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';

const SelectionButtonTypes = MojitoModules.SelectionButton.types;

const EVENT_CARD_OVER_UNDER_DESCRIPTORS = {
    categories: {
        OVER_UNDER: {selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT},
        OVER_EXACTLY_UNDER: {selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT},
        OVER_UNDER_THREE_WAY: {selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT},
    },
};

export function matchCardsFactory(PALETTE, COLOR_MODE) {
    return {
        MatchEventCardClassic: {
            mode: COLOR_MODE,
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            headerContainer: {
                style: {
                    padding: '0 8px 6px',
                    alignItems: 'center',
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'auto',
                },
            },
            eventCardDetails: generateMatchEventCardClassicDetails(PALETTE.CARD_EVENT_DETAILS_LIGHT),
            eventCardDetailsDark: generateMatchEventCardClassicDetails(PALETTE.CARD_EVENT_DETAILS_DARK),
        },
    };
}

function generateMatchEventCardClassicDetails(CARD_DETAILS) {
    const CARD_SCOREBOARD = generateScoreboard({
        ...CARD_DETAILS.SCOREBOARD,
        SCOREBOARD_PARTICIPANTS: CARD_DETAILS.PARTICIPANTS,
        SCOREBOARD_TIMING_STATUS: CARD_DETAILS.TIMING_STATUS,
    });
    const CARD_MINI_SCOREBOARD = merge(generateBaseScoreboard(CARD_DETAILS.SCOREBOARD), {
        scoresTextMain: {
            backgroundImage: 'initial',
            ...resolveBackground(CARD_DETAILS.SCOREBOARD.SCOREBOARD_ACTIVE_SCORE_BG),
            ...CARD_DETAILS.SCOREBOARD.SCOREBOARD_ACTIVE_SCORE_TEXT,
        },
        scoresTextSecondary: {
            width: '20px',
            ...CARD_DETAILS.SCOREBOARD.SCOREBOARD_SCORE_TEXT,
        },
        scoreCount: {
            style: {
                scoreText: {
                    backgroundImage: 'initial',
                    ...resolveBackground(CARD_DETAILS.SCOREBOARD.SCOREBOARD_ACTIVE_SCORE_BG),
                    ...CARD_DETAILS.SCOREBOARD.SCOREBOARD_ACTIVE_SCORE_TEXT,
                },
            },
        },
    });
    const EVENT_CARD_ODDS_BUTTON = merge(generateOddsButton(CARD_DETAILS.ODDS_BUTTON), {
        view: {
            infoText: {
                ellipsisOnLineNumber: 1,
            },
        },
    });

    return {
        eventCard: {
            title: {
                truncate: true,
                style: CARD_DETAILS.EVENT_NAME_TEXT,
            },
        },
        genericMarketContent: {
            layoutDescriptors: EVENT_CARD_OVER_UNDER_DESCRIPTORS,
            container: {
                style: {
                    backgroundColor: 'transparent',
                    backgroundImage: 'none',
                },
            },
            market: {
                selectionButton: EVENT_CARD_ODDS_BUTTON,
            },
        },
        gameLineMarketContent: {
            layoutDescriptors: EVENT_CARD_OVER_UNDER_DESCRIPTORS,
            container: {
                style: {
                    flexBasis: 0,
                    backgroundColor: 'transparent',
                    backgroundImage: 'none',
                },
            },
            marketsContainer: {
                style: {
                    _mobile_flexBasis: 'auto',
                },
            },
            market: {
                headerLabel: {
                    style: CARD_DETAILS.GAMELINE_MARKET_HEADER_TEXT,
                },
                selectionButton: generateOddsButton(CARD_DETAILS.ODDS_BUTTON),
            },
            participants: merge(generateParticipants(CARD_DETAILS.PARTICIPANTS), {
                participantItem: {
                    textWrapper: {
                        style: {
                            justifyContent: 'center',
                        },
                    },
                },
            }),
            scoreboard: CARD_MINI_SCOREBOARD,
        },
        playerPropMarketContent: {
            layoutDescriptors: EVENT_CARD_OVER_UNDER_DESCRIPTORS,
        },
        marketTitle: {
            style: CARD_DETAILS.MARKET_NAME_TEXT,
        },
        headerTime: generateEventTimingStatus(CARD_DETAILS.TIMING_STATUS),
        sportIcon: {
            icon: {
                style: {
                    fill: CARD_DETAILS.SPORT_ICON_COLOR,
                    minWidth: 12,
                },
            },
        },
        eventItemDetails: {
            container: {
                style: {
                    padding: '0 8px 8px',
                },
            },
            participants: merge(generateParticipants(CARD_DETAILS.PARTICIPANTS), {
                participantItem: {
                    text: {
                        container: {
                            display: 'flex',
                            padding: '2px 0', // same as scoreText in miniScoreboard, see DBX-7944
                        },
                        style: {
                            lineHeight: '16px',
                        },
                    },
                },
            }),
            scoreboard: merge(CARD_MINI_SCOREBOARD, {
                scoreCount: {
                    style: {
                        goalContainer: {
                            zIndex: 'auto',
                        },
                    },
                },
            }),
        },
        scoreboard: merge(CARD_SCOREBOARD, {
            container: {
                style: {
                    padding: '0 8px',
                    backgroundImage: 'none',
                },
            },
            content: {
                style: {
                    backgroundColor: 'none',
                    _desktop_boxShadow: 'none',
                    _mobile_boxShadow: 'none',
                },
            },
        }),
    };
}
